import React from 'react';
import { Cookie } from 'lucide-react';
import { Button } from '../components/ui/button';

const CookieBanner = ({ open, onAccept, onReject }) => {
  if (!open) return null;
  return (
    <div className="fixed bottom-3 left-3 sm:left-auto sm:right-4 sm:bottom-4 sm:max-w-[380px] z-[80] rounded-xl border border-cyan-900/50 bg-[#0a1d22]/95 backdrop-blur-md p-3.5 fade-in"
         style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.6)' }}>
      <div className="flex items-start gap-2.5">
        <Cookie className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" />
        <div className="flex-1">
          <div className="text-[13px] font-semibold text-cyan-50 mb-1">Cookies & tracking</div>
          <p className="text-[12px] text-cyan-300/80 leading-relaxed">
            We use a small number of <b className="text-cyan-100">essential</b> cookies for the site to work.
            With your consent we also use <b className="text-cyan-100">analytics</b> (anonymised stats).
          </p>
          <div className="flex items-center gap-1.5 mt-2.5">
            <Button onClick={onReject} variant="outline" size="sm"
                    className="h-7 text-[11.5px] bg-transparent border-cyan-800/50 text-cyan-200 hover:bg-cyan-500/10 hover:text-cyan-50">
              Reject all
            </Button>
            <Button onClick={onAccept} size="sm"
                    className="h-7 text-[11.5px] bg-cyan-400 hover:bg-cyan-300 text-[#062126] font-semibold">
              Accept all
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
